import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Avatar, DatePicker, Form, Input, Spin, Select, Image, Upload, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Lock from "../../../assets/auth/Lock";
import { ChangePasswordApi, LogoutApi, GetUserApi, UpdateUserApi, UpdateParentDetaialsApi, GetUserInfoApi, UpdateUserInfoApi, Request2faChangeApi } from "../../../api/request/users.js";
import { GetAllCountryApi } from "../../../api/request/common.js";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import { setloggedIn, setUserDetails } from "../../../store/slices/userSlice.js";
import { removeCookies } from "../../../services/Cookies.jsx";
import { useNavigate } from "react-router-dom";
import Edit from "../../../assets/Edit.jsx";
import Copy from "../../../components/copy/Copy.jsx";
import moment from "moment";
import ModalComponent from "../../../components/modals/ModalComponent.jsx";
import dayjs from 'dayjs';
import TwoFAModal from "./components/TwoFAModal.jsx";

const { Dragger } = Upload;

export default function Profile({ isDrawer }) {

  const [form] = Form.useForm();
  const [updateForm] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);
  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [getUserInfoLoading, setGetUserInfoLoading] = useState(false);
  const [updateInitialValues, setUpdateInitialValues] = useState({ FirstName: '', LastName: '', PhoneNo: '', ProfileImage: '', DOB: '', Skype: '', Telegram: '', Facebook: '', LinkedIn: '', ExpAsIb: '', NumberofClients: '', WorkingExp: '', Fax: '', Telephone: '', CountryOfBirth: null, CountryOfCitizenship: null, City: '', RecoveryContact: '', FamilyName: '' });
  const [isLoadingProfileUpdate, setIsLoadingProfileUpdate] = useState(false);
  const [isOpenProfileUpdateModal, setIsOpenProfileUpdateModal] = useState(false);
  const [countries, setCountries] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [profileImagePath, setProfileImage] = useState('');
  const [fileList, setFileList] = useState([]);
  const [parentChecked, setParentChecked] = useState(false);
  const [userInfo, setUserInfo] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isOpen2FAModal, setIsOpen2FAModal] = useState(false);

  const getBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    updateForm.setFieldsValue({ ProfileImage: newFileList });
    if (newFileList?.length === 0) {
      updateForm.setFieldsValue({ ProfileImage: null });
    }
  }

  const UploadButton = (
    <button type="button">
      <div className="flex justify-center"><img src="/assets/icons/Upload_Document_icon.svg" alt="icon" /></div>
      Upload
    </button>
  );

  const filterOption = (input, option) => {
    return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  };

  const getContriens = async () => {
    try {
      const { data } = await GetAllCountryApi();
      if (data?.success) {
        setCountries(
          data?.data?.map((item) => ({
            ...item,
            value: item?.id,
            label: item?.countryName,
          }))
        );
      }
    } catch (error) { }
  };

  const handleSubmit = async (values) => {
    const { currentPassword, newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }

    const params = {
      id: userDetails?.id,
      currentPassword,
      newPassword: newPassword,
    };
    try {
      setIsLoading(true);
      const { data } = await ChangePasswordApi(params);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        logoutHandler();
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsLoading(false);
    }
  };

  const logoutHandler = async () => {
    try {
      setIsLoading(true);
      const { data } = await LogoutApi(userDetails?.id);
      if (data?.success) {
      }
      localStorage.clear();
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
      setIsLoading(false);
    } catch (err) {
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
    }
  };

  useEffect(() => {
    if (!isDrawer) {
      form.resetFields();
    }
    if (isDrawer) {
      getParentStatus();
    }
  }, [isDrawer]);

  const getUser = async () => {
    try {
      setIsLoadingProfile(true);
      const { data } = await GetUserApi(userDetails?.id);
      setUser(data?.data);
      if (data?.data?.profileImagePath) {
        setPreviewImage(data?.data?.profileImagePath);
      }
      updateForm.setFieldsValue({
        FirstName: data?.data?.firstName,
        LastName: data?.data?.lastName,
        PhoneNo: data?.data?.phoneNo,
        ProfileImage: data?.data?.profileImagePath,
        DOB: data?.data?.dob && moment(moment(data?.data?.dob).format('MM/DD/YYYY'), 'MM/DD/YYYY'),
        Skype: data?.data?.skype,
        Telegram: data?.data?.telegram,
        Facebook: data?.data?.facebook,
        LinkedIn: data?.data?.linkedIn,
        ExpAsIb: data?.data?.expAsIb,
        NumberofClients: data?.data?.numberofClients,
        WorkingExp: data?.data?.workingExp,
        Fax: data?.data?.fax,
        Telephone: data?.data?.telephone,
        CountryOfBirth: data?.data?.countryOfBirthId,
        CountryOfCitizenship: data?.data?.countryOfCitizenshipId,
        City: data?.data?.city,
        RecoveryContact: data?.data?.recoveryContact,
        FamilyName: data?.data?.familyName
      });
      dispatch(setUserDetails({ ...userDetails, profileImagePath: data?.data?.profileImagePath }));
      setIsLoadingProfile(false);
    } catch (error) {
      setIsLoadingProfile(false);
    }
  }


  useEffect(() => {
    getUser();
    getUserInfo();
  }, [isOpenProfileUpdateModal]);

  const updateUserProfile = async (values) => {
    const extractOriginFileObjs = (fileArray) => {
      if (!fileArray || fileArray.length === 0) {
        return null;
      }
      return fileArray[0]?.originFileObj;
    };
    try {
      setIsLoadingProfileUpdate(true);
      let apiHeader = { headers: { Accept: "application/json", "Content-Type": "multipart/form-data" } };
      let params = {
        UserId: userDetails?.id,
        DOB: updateForm.getFieldValue('DOB') ? moment(updateForm.getFieldValue('DOB')).format('MM/DD/YYYY') : '',
        ...values
      }
      delete params.ProfileImage;
      delete params.Username;
      const updateUserPayload = {
        userId: userInfo?.userId,
        clientId: userInfo?.clientId,
        firstName: userInfo?.firstName || "",
        lastName: userInfo?.lastName || "",
        phone: userInfo?.phone || "",
        fax: userInfo?.fax || "",
        mobile: userInfo?.mobile || values?.PhoneNo,
        telPW: userInfo?.telPW || "",
        pob: userInfo?.pob || "",
        countryId: userInfo?.countryId,
        address: userInfo?.address || "",
        readOnlyLogin: userInfo?.readOnly || false,
        forceChangePassword: userInfo?.forceChangePW || false,
        city: userInfo?.city || "",
        userName: values.Username || userInfo?.username,
      };
      const { data } = await UpdateUserApi({ ...params, ProfileImage: extractOriginFileObjs(values?.ProfileImage) }, apiHeader);
      if (data?.success) {
        setIsOpenProfileUpdateModal(false);
        updateForm.resetFields();
        setFileList([]);
        setPreviewImage('');
        setPreviewOpen(false);
        toast.success(data?.message);
      }
      const [profileUpdateRes, userNameUpdateRes] = await Promise.all([
        UpdateUserApi({ ...params, ProfileImage: extractOriginFileObjs(values?.ProfileImage) }, apiHeader),
        UpdateUserInfoApi(updateUserPayload)
      ]);
      if (profileUpdateRes?.data?.success && userNameUpdateRes?.data?.success) {
        setIsOpenProfileUpdateModal(false);
        updateForm.resetFields();
        setFileList([]);
        setPreviewImage('');
        setPreviewOpen(false);
        toast.success(profileUpdateRes?.data?.message);
      }
      setIsLoadingProfileUpdate(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLoadingProfileUpdate(false);
    }
  }

  const openUpdateHandle = () => {
    getContriens();
    setIsOpenProfileUpdateModal(true);
  }

  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = dayjs(date).format('MM/DD/YYYY');
      updateForm.setFieldsValue({
        DOB: moment(formattedDate, 'MM/DD/YYYY'),
      });
    } else {
      updateForm.setFieldsValue({
        DOB: '',
      });
    }
  };

  const getParentStatus = async () => {
    try {
      const { data } = await UpdateParentDetaialsApi({ getUpdateParentStatus: 0 });
      if (data?.success) {
        setParentChecked(data?.data?.parentVisible);
      }
    } catch (error) { }
  };


  const handleParentChange = async (checked) => {
    const param = {
      getUpdateParentStatus: 1,
      status: checked
    };
    try {
      const { data } = await UpdateParentDetaialsApi(param);
      if (data?.success) {
        setParentChecked(checked);
        toast.success(data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.message);
      }
    }
  }

  const getUserInfo = async () => {
    setGetUserInfoLoading(true);
    try {
      const { data } = await GetUserInfoApi(userDetails?.id);
      if (data?.success) {
        setUserInfo(data?.data);
        updateForm.setFieldsValue({ Username: data?.data?.username });
        setGetUserInfoLoading(false);
      }
    } catch (error) {
    }
  };


  const openInNewTab = (url) => {
    window.open(url, "_blank");
  };

  const open2FAHandle = async () => {
    setLoading(true);
    try {
      const params = { IsEnable: !userDetails?.verifyWithOpt };
      const { data } = await Request2faChangeApi(params);
      if (data?.success) setIsOpen2FAModal(true);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="border rounded-lg flex justify-between items-start p-5">
        <div className="flex items-center">
          <Avatar size={60} className="uppercase bg-primary" src={user?.profileImagePath}>{user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}</Avatar>
          <div className="ml-4">
            <p className="font-medium text-lg">{user?.firstName} {user?.lastName}</p>
            <p className="text-[#848484] text-lg mt-1">
              {userDetails?.address}
            </p>
          </div>
        </div>
      </div>

      <div className="border rounded-lg p-4 mt-4">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <p className="font-medium text-xl">Personal Information</p>
          <div className="cursor-pointer" onClick={openUpdateHandle}>
            <Edit />
          </div>
        </div>
        {
          isLoadingProfile && getUserInfoLoading ? (
            <div className="flex justify-center flex-col my-[40%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 grid-cols-1 mt-5 items-center gap-5">
              <div>
                <p className="text-[#848484] font-normal text-base">First Name</p>
                <p className="primary font-semibold text-base mt-1">{user?.firstName || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Last Name</p>
                <p className="primary font-semibold text-base mt-1">{user?.lastName || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">User Name</p>
                <p className="primary font-semibold text-base mt-1">{userInfo?.username || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Email Address</p>
                <p className="primary font-semibold text-base mt-1">{user?.email || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">City</p>
                <p className="primary font-semibold text-base mt-1">{user?.city || '--'}</p>
              </div>
              {user?.skype &&
                <div>
                  <p className="text-[#848484] font-normal text-base">Skype</p>
                  <div className="flex items-center gap-3">
                    <p className="primary font-semibold text-base mt-1 cursor-pointer hover:underline" onClick={() => openInNewTab(user?.skype)}>Open Profile</p>
                    <Copy text={user?.skype} />
                  </div>
                </div>
              }
              {user?.telegram &&
                <div>
                  <p className="text-[#848484] font-normal text-base">Telegram</p>
                  <div className="flex items-center gap-3">
                    <p className="primary font-semibold text-base mt-1 cursor-pointer hover:underline" onClick={() => openInNewTab(user?.telegram)}>Open Profile</p>
                    <Copy text={user?.telegram} />
                  </div>
                </div>
              }
              {user?.facebook &&
                <div>
                  <p className="text-[#848484] font-normal text-base">Facebook</p>
                  <div className="flex items-center gap-3">
                    <p className="primary font-semibold text-base mt-1 cursor-pointer hover:underline" onClick={() => openInNewTab(user?.facebook)}>Open Profile</p>
                    <Copy text={user?.facebook} />
                  </div>
                </div>
              }
              {user?.linkedIn &&
                <div>
                  <p className="text-[#848484] font-normal text-base">LinkedIn</p>
                  <div className="flex items-center gap-3">
                    <p className="primary font-semibold text-base mt-1 cursor-pointer hover:underline" onClick={() => openInNewTab(user?.linkedIn)}>Open Profile</p>
                    <Copy text={user?.linkedIn} />
                  </div>
                </div>
              }
              <div>
                <p className="text-[#848484] font-normal text-base">Experience As IB</p>
                <p className="primary font-semibold text-base mt-1">{user?.expAsIb || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Number Of Clients</p>
                <p className="primary font-semibold text-base mt-1">{user?.numberofClients || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Working Experience</p>
                <p className="primary font-semibold text-base mt-1">{user?.workingExp || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Fax</p>
                <p className="primary font-semibold text-base mt-1">{user?.fax || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Telephone</p>
                <p className="primary font-semibold text-base mt-1">{user?.telephone || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Date Of Birth</p>
                <p className="primary font-semibold text-base mt-1">{user?.dob ? moment(user?.dob).format('DD/MM/YYYY') : '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Country Of Birth</p>
                <p className="primary font-semibold text-base mt-1">{user?.countryOfBirthName || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Country Of Citizenship</p>
                <p className="primary font-semibold text-base mt-1">{user?.countryOfCitizenshipName || '--'}</p>
              </div>
              <div>
                <p className="text-[#848484] font-normal text-base">Recovery Contact</p>
                <p className="primary font-semibold text-base mt-1">{user?.recoveryContact || '--'}</p>
              </div>
            </div>
          )
        }
      </div>
      {
        (user?.ibUser === 'Yes') &&
        (
          <div className='flex items-center border rounded-lg p-4 mt-4'>
            <Switch checkedChildren="ON" unCheckedChildren="OFF" checked={parentChecked} onChange={handleParentChange} />
            <p className='text-[#848484] font-semibold text-base ms-2'>Visible as Parent</p>
          </div>
        )
      }

      <div className='flex items-center border rounded-lg p-4 mt-4'>
        <Switch
          checkedChildren="ON"
          unCheckedChildren="OFF"
          checked={userDetails?.verifyWithOpt}
          loading={loading}
          onClick={open2FAHandle}
        />
        <p className='text-[#848484] font-semibold text-base ms-2'>Two Factor Authentication (2FA)</p>
      </div>

      <Form autoComplete="off" onFinish={handleSubmit} form={form}>
        <div className="p-5 grid grid-cols-1 gap-6">
          <div>
            <p className="text-xl font-medium">Change Password</p>
            <p className="mt-1 text-sm">
              To change your password, please fill in the below fields.
            </p>
          </div>
          <div className="sm:w-[65%] w-full">
            <p className="mb-1">Current Password</p>
            <Form.Item
              name="currentPassword"
              rules={[
                {
                  required: true,
                  message: "Please input your current password!",
                },
              ]}
            >
              <Input.Password
                size="large"
                placeholder="Current Password"
                prefix={<Lock />}
              />
            </Form.Item>
          </div>
          <div className="sm:w-[65%] w-full">
            <p className="mb-1">New Password</p>
            <Form.Item
              name="newPassword"
              hasFeedback
              rules={[
                { required: true, message: "Please input your new password!" },
              ]}
            >
              <Input.Password
                size="large"
                placeholder="New Password"
                prefix={<Lock />}
              />
            </Form.Item>
          </div>
          <div className="sm:w-[65%] w-full">
            <p className="mb-1">Confirm Password</p>
            <Form.Item
              dependencies={['newPassword']}
              hasFeedback
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: "Please confirm your new password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('The new password that you entered do not match!'));
                  },
                }),
              ]}
            >
              <Input.Password
                size="large"
                placeholder="Confirm Password"
                prefix={<Lock />}
              />
            </Form.Item>
          </div>
          <div className="sm:w-[65%] w-full ">
            <LoadableButton
              type="submit"
              className="w-full text-base font-medium py-2 px-2 rounded-lg text-white bg-primary themeHover"
              lable="Change Password"
              isLoading={isLoading}
              loadingLable="Updating..."
            />
          </div>
        </div>
      </Form>

      <ModalComponent isOpen={isOpenProfileUpdateModal} setIsOpen={setIsOpenProfileUpdateModal} title='Update your profile' width={1200}>
        {getUserInfoLoading ? (
          <div className="flex justify-center flex-col my-[40%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <Form className="w-full" initialValues={updateInitialValues} autoComplete="off" form={updateForm} onFinish={updateUserProfile}>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">First Name</label>
                <Form.Item name="FirstName" rules={[{ required: true, message: "Please enter first name." }]}>
                  <Input placeholder="First name" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Last Name</label>
                <Form.Item name="LastName" rules={[{ required: true, message: "Please enter last name." }]}>
                  <Input placeholder="Last name" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Username</label>
                <Form.Item name="Username" rules={[{ required: true, message: "Please enter username." }]}>
                  <Input placeholder="Username" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Phone No.</label>
                <Form.Item name="PhoneNo" rules={[{ required: true, message: "Please enter valid phone number." }]}>
                  <Input type="number" placeholder="Phone no." className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Date Of Birth</label>
                <Form.Item>
                  <DatePicker placeholder="Date of birth" className="mt-1 w-full py-2" defaultValue={updateForm.getFieldValue('DOB') && dayjs(moment(updateForm.getFieldValue('DOB')).format('MM/DD/YYYY'), 'MM/DD/YYYY')} onChange={handleDateChange} format='MM/DD/YYYY' />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">City</label>
                <Form.Item name="City" >
                  <Input placeholder="City" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Skype</label>
                <Form.Item name="Skype" >
                  <Input placeholder="Skype" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Telegram</label>
                <Form.Item name="Telegram" >
                  <Input placeholder="Telegram" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Facebook</label>
                <Form.Item name="Facebook" >
                  <Input placeholder="Facebook" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">LinkedIn</label>
                <Form.Item name="LinkedIn" >
                  <Input placeholder="LinkedIn" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Experience As IB</label>
                <Form.Item name="ExpAsIb">
                  <Input type="number" placeholder="Experience as ib" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Number Of Clients</label>
                <Form.Item name="NumberofClients">
                  <Input type="number" placeholder="Number of clients" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Working Experience</label>
                <Form.Item name="WorkingExp">
                  <Input type="number" placeholder="Working experience" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Fax</label>
                <Form.Item name="Fax" >
                  <Input placeholder="Fax" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Telephone</label>
                <Form.Item name="Telephone">
                  <Input type="number" placeholder="Telephone" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="ant-select-selector-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Country Of Birth</label>
                <Form.Item name="CountryOfBirth">
                  <Select showSearch placeholder="Select a country of birth" className="w-full mt-1" filterOption={filterOption} options={countries} />
                </Form.Item>
              </div>
              <div className="ant-select-selector-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Country Of Citizenship</label>
                <Form.Item name="CountryOfCitizenship">
                  <Select showSearch placeholder="Select a country of citizenship" className="w-full mt-1" filterOption={filterOption} options={countries} />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Recovery Contact</label>
                <Form.Item name="RecoveryContact">
                  <Input type="number" placeholder="Recovery contact" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Family Name</label>
                <Form.Item name="FamilyName" >
                  <Input placeholder="Family name" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
            </div>
            <div className="pt-5 md:w-1/3 sm:w-1/2 w-full">
              <label className="text-base text-[#2F2B3DCC] font-medium">Profile Picture</label>
              <div className="flex w-full items-center justify-between">
                <Form.Item name="ProfileImage">
                  <Upload beforeUpload={() => false} listType="picture-card" className="mt-1" fileList={fileList} onPreview={handlePreview} onChange={handleChange}>{fileList.length >= 1 ? null : UploadButton}</Upload>
                </Form.Item>
                {user?.profileImagePath &&
                  <div className="ms-4 h-32 w-32 my-auto"><img src={user?.profileImagePath} alt="preview" className="object-cover w-full h-full" /></div>
                }
              </div>
              <p className="text-sm text-[#2F2B3DCC] font-medium ">Profile picture should be maximum 2MB!</p>
              {previewImage && (
                <Image
                  wrapperStyle={{ display: 'none' }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) => setPreviewOpen(visible),
                    afterOpenChange: (visible) => !visible && setPreviewImage(''),
                  }}
                  src={previewImage}
                />
              )}
            </div>
            <div className="flex justify-end mt-8">
              <LoadableButton
                className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
                disabled={isLoadingProfileUpdate}
                type="Submit"
                lable="Update"
                isLoading={isLoadingProfileUpdate}
                loadingLable="Updating profile..."
              />
            </div>
          </Form>
        )}
      </ModalComponent>

      <TwoFAModal isOpen={isOpen2FAModal} setIsOpen={setIsOpen2FAModal} />
    </div>
  );
}
